import { MessageCircle, X } from "lucide-react";
import { useState } from "react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

export function ChatBubble() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/chat');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Button
        onClick={handleClick}
        size="lg"
        className="rounded-full shadow-lg hover:shadow-xl transition-all duration-200 h-14 w-14 p-0"
        aria-label="Abrir chat de asistencia"
      >
        <MessageCircle className="h-6 w-6" aria-hidden="true" />
      </Button>
    </div>
  );
}